"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLang } from "@/contexts/language-context";
import { ArrowRight } from "lucide-react";

export default function MicrositeCta() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-[#0A0814] text-white overflow-hidden">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(124,58,237,0.30) 0%, transparent 60%)" }}
      />
      <div
        className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(244,114,182,0.20) 0%, transparent 65%)" }}
      />

      <div className="relative max-w-[800px] mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-6" style={{ color: "#F472B6" }}>
            {t("DMs Sunday: \"What's tonight?\"", "DMs el domingo: \"¿Qué hay esta noche?\"")}
          </div>
          <h2 className="text-4xl md:text-[72px] font-black tracking-[-0.03em] leading-[1.02] mb-8">
            {t("Send them", "Mándalos")}
            <br />
            <span
              style={{
                background: "linear-gradient(135deg, #C4B5FD 0%, #F472B6 50%, #FB923C 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {t("a link.", "un link.")}
            </span>
          </h2>
          <p className="text-[16px] md:text-[18px] font-medium text-white/60 max-w-[520px] mx-auto leading-relaxed mb-10">
            {t(
              "Public venue page with upcoming events, branded look, ticket checkout, custom domain on Nightlife PRO. Auto-updated. Built into your Nightlife account.",
              "Página pública del venue con eventos próximos, branded, ticket checkout, dominio custom en Nightlife PRO. Auto-actualizado. Incorporado a tu cuenta Nightlife."
            )}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/signup?vertical=nightlife"
              className="group inline-flex items-center gap-2 text-[15px] font-bold px-8 py-4 rounded-full hover:scale-[1.03] transition-transform shadow-2xl text-white"
              style={{
                background: "linear-gradient(135deg, #7C3AED 0%, #F472B6 100%)",
                boxShadow: "0 20px 60px rgba(124, 58, 237, 0.5)",
              }}
            >
              {t("Get your venue site live →", "Pon tu sitio en vivo →")}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              href="/solution/nightlife"
              className="inline-flex items-center text-[14px] font-bold text-white/70 hover:text-white transition-colors px-4 py-2"
            >
              {t("See the full nightlife pitch →", "Ver el pitch completo →")}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
